import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '~/constants/routes'

const routes: RouteRecordRaw[] = [
  {
    component: () => import('./pages/NoAccess.vue'),
    name: ROUTE_NAMES.NO_ACCESS,
    path: '/bo-seller/no-access',
    meta: {
      owners: ['bot-squad-seller-experience-front'],
    },
  },
]

export default routes
